import Services from './index';
import {
  CANCEL_IMPORT_URL,
  DELETE_PREVIEW_FILE_URL,
  GET_ALL_RUNNING_CONTACT_IMPORT_URL,
  MANAGE_CONTACTS_SERVLET_URL,
  MERGE_GROUPS_URL,
} from 'consts/api';
import { parseToQuerystringTarget } from 'helpers/target';

import querystring from 'query-string';

const API_CONTACT_URL = '/tb/api/v2/authenticated/contact';

class ManageContactServices {
  //! V2
  totalContactV2(body = { groupId: '', target: [] }, configs) {
    const { target, groupId } = body;
    return Services.post(`${API_CONTACT_URL}/totalContact?groupId=${groupId}`, target, configs);
  }

  searchContactV2(
    body = {
      groupId: 0,
      pageSize: 50,
      page: 1,
      index: null,
      searchTagDtos: [],
    },
    configs
  ) {
    return Services.post(`${API_CONTACT_URL}/searchContact`, body, configs);
  }

  //! V1
  addNewContactGroup(
    body = {
      groupName: '',
      country: '',
      isCreateAR: false,
      isSuppression: false,
      type: '',
    }
  ) {
    // The deployed contact service implements addGroup as a ManageContactsServlet
    // action; the REST `/contact/addGroup` path 404s (the UI was migrated to REST
    // ahead of the backend). Route through the servlet — cloud-webapp forwards it
    // with the authenticated userId injected, and returns the created group JSON
    // (or "EXIST"/"MINLENGTH3"). `type` is the numeric ContactGroupType id
    // (myData='0'). See decision-34 / TASK-197.
    const { groupName = '', country = '', type = '' } = body;
    const qs = querystring.stringify({ action: 'addGroup', groupName, country, type });
    return Services.post(`${MANAGE_CONTACTS_SERVLET_URL}?${qs}`);
  }

  getContactFields({ groupId }) {
    return Services.get(
      `${MANAGE_CONTACTS_SERVLET_URL}?action=getContactFields&groupId=${groupId}`
    );
  }

  searchContact({ groupId, filters }) {
    const { pageSize = 50, page = 1, targets = [], sortField, direction } = filters;
    const targetToString = parseToQuerystringTarget(targets);
    return Services.get(
      `${MANAGE_CONTACTS_SERVLET_URL}?action=searchContact&groupId=${groupId}&pageSize=${pageSize}&page=${page}&sortField=${sortField}&direction=${direction}&${targetToString}`
    );
  }

  loadContactFields() {
    return Services.get(`${MANAGE_CONTACTS_SERVLET_URL}?action=loadContactFields`);
  }

  getFiltersContactFields() {
    return Services.get(`${MANAGE_CONTACTS_SERVLET_URL}?action=getContactFields`);
  }

  getContactTagsFields() {
    return Services.get(`${MANAGE_CONTACTS_SERVLET_URL}?action=getContactTags`);
  }

  totalContact({ groupId, filters = {}, body = {} }) {
    const { targets = [] } = filters;
    const targetToString = parseToQuerystringTarget(targets);
    return Services.get(
      `${MANAGE_CONTACTS_SERVLET_URL}?action=totalContact&groupId=${groupId}&${targetToString}&${querystring.stringify(
        body
      )}`
    );
  }

  addPhoneToOptout(phone) {
    return Services.get(`${MANAGE_CONTACTS_SERVLET_URL}?action=addPhoneToOptout&phone=${phone}`);
  }

  mergeContact({ groupSeleted, deleteOrigin, groupNames }) {
    return Services.post(MERGE_GROUPS_URL, {
      groupNames,
      groupIds: groupSeleted,
      deleteOriginalGroup: deleteOrigin,
    });
  }

  certingContactGroup(body = { groupId: '', vertical: '', website: '', refresh: true }) {
    return Services.post(`${API_CONTACT_URL}/dataCertingGroup`, body);
  }

  certingUpdateContactGroup(body = { groupId: '', vertical: '' }) {
    return Services.post(`${API_CONTACT_URL}/dataCertingUpdate`, body);
  }

  getListCertingVertical() {
    return Services.get(`${API_CONTACT_URL}/certingVertical`);
  }

  getAllCertingHistory(
    body = {
      groupId: 667414,
      vertical: 'HEALTHCARE',
      limit: 10,
      offset: 0,
    }
  ) {
    return Services.post(`${API_CONTACT_URL}/getAllDataCertingHistory`, body);
  }

  /**
   *
   * @param {{ groupId: number }} props
   * @returns {{ data: RunningProcessContactGroup}}
   */
  getRunningProcess({ groupId }) {
    return Services.post(`${API_CONTACT_URL}/getRunningProcess?groupId=${groupId}`);
  }

  deleteContact(body) {
    return Services.post(
      `${MANAGE_CONTACTS_SERVLET_URL}`,
      querystring.stringify({
        action: 'removeContacts',
        ...body,
      })
    );
  }

  //* TA-12175
  getAllRunningImportProcess() {
    return Services.get(GET_ALL_RUNNING_CONTACT_IMPORT_URL);
  }

  deleteFileUploaded(groupId) {
    return Services.get(`${DELETE_PREVIEW_FILE_URL}?groupId=${groupId}`);
  }

  cancelImport({ groupId }) {
    return Services.post(`${CANCEL_IMPORT_URL}?groupId=${groupId}`);
  }

  uploadFileToStorageV2({ groupId, delimiter, files } = {}) {
    const formData = new FormData();
    formData.append('groupId', groupId);
    formData.append('delimiter', delimiter);

    for (let file of files) {
      formData.append('files', file);
    }
    return Services.post(`${API_CONTACT_URL}/uploadFileToStorageV2`, formData);
  }

  importFromStorageV2(
    body = {
      groupId: 123,
      fileHeaders: {
        'Export_contact_ US Jul4_split_5_split_3 (1).csv':
          '{"11":"browser","12":"phoneBrand","13":"phoneType","14":"stateCode","15":"Subaff1","16":"Subaff2","0":"fName","1":"lName","2":"phone","3":"carrier","4":"ProvinceStateName","5":"vehicleMaker","6":"vehicleModel","7":"vehicleYear","8":"vertical","9":"zipCode","10":"address"}',
        'Export_contact_ D0405 - Auto resend_12347_failed.csv':
          '{"11":"zipCode","44":"EVID","12":"stateCode","49":"campaignTitle","1":"fName","2":"lName","3":"phone","4":"carrier","6":"email","9":"address","30":"gender","20":"phoneType","10":"city"}',
      },
    }
  ) {
    return Services.post(`${API_CONTACT_URL}/importFromStorageV2`, body);
  }

  deleteFileV2(body = { groupId: 123, fileNames: [''] }) {
    return Services.post(`${API_CONTACT_URL}/deleteFileV2`, body);
  }

  getAIMapping(body = { groupId: 123, fileNames: ['Export_contact_ Philippines.csv'] }) {
    return Services.post(`${API_CONTACT_URL}/getAiMapping`, body);
  }

  unarchiveGroup(body = [678749, 678750]) {
    return Services.post(`${API_CONTACT_URL}/unarchiveGroup`, body);
  }

  saveFileHeaders(
    body = {
      groupId: '',
      fileHeaders: {
        'Export_contact_ check_allow_dnc(1).csv': '{"2":"phone"}',
        'Export_contact_ AU_ADX_ALL.csv': '{"2":"phone"}',
      },
    }
  ) {
    return Services.post(`${API_CONTACT_URL}/save-file-headers`, body);
  }

  getIndustrialVertical(configs) {
    // Backend endpoint /user/industrial-vertical/enums doesn't exist (replica
    // or legacy). Return the canonical 10DLC industry vertical list so brand
    // setup and DID-group forms have populated options. Values follow the
    // TCR/CTIA standard naming so they match what carriers expect.
    return Promise.resolve({
      data: [
        'PROFESSIONAL',
        'REAL_ESTATE',
        'HEALTHCARE',
        'HUMAN_RESOURCES',
        'ENERGY',
        'ENTERTAINMENT',
        'RETAIL',
        'TRANSPORTATION',
        'AGRICULTURE',
        'INSURANCE',
        'POSTAL',
        'EDUCATION',
        'HOSPITALITY',
        'FINANCIAL',
        'POLITICAL',
        'GAMBLING',
        'LEGAL',
        'CONSTRUCTION',
        'NGO',
        'MANUFACTURING',
        'GOVERNMENT',
        'TECHNOLOGY',
        'COMMUNICATION',
      ],
    });
  }
}

export default new ManageContactServices();
